var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatpage"},[_c('h5',[_vm._v("Showing messages for: "+_vm._s(_vm.$route.params.id))]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }